export const GET_DATA_SUBJECT_RIGHT_MANAGEMENT_DASHBOARD =
  "GET_DATA_SUBJECT_RIGHT_MANAGEMENT_DASHBOARD";
export const GET_DATA_SUBJECT_RIGHT_MANAGEMENT_DASHBOARD_SUCCESS =
  "GET_DATA_SUBJECT_RIGHT_MANAGEMENT_DASHBOARD_SUCCESS";
export const CHANGE_DATA_SUBJECT_RIGHT_MANAGEMENT_DASHBOARD_FILTER =
  "CHANGE_DATA_SUBJECT_RIGHT_MANAGEMENT_DASHBOARD_FILTER";
